import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/probability-calculator',
  component: () => import('../../routes/ProbabilityCalculator.svelte'),
  card: {
    id: 'probability-calculator',
    title: 'Probability Calculator',
    description: 'Calculate binomial probabilities, combined AND/OR chances, permutations and combinations. Perfect for dice, cards, and game odds.',
    icon: 'casino',
    iconBgClass: 'bg-purple-50',
    iconTextClass: 'text-purple-600',
    href: '/probability-calculator',
    category: 'Conversion & Math',
  },
  seo: {
    title: 'Probability Calculator – Binomial, Permutations & Combinations',
    description:
      'Free probability calculator to find odds of success in repeated trials, calculate combined AND/OR probabilities, and compute permutations and combinations. Ideal for dice rolls, card games, and statistics.',
  },
};

export default meta;
